import { useEffect } from 'react';

export function usePageVisibility(onVisibilityChange: (hidden: boolean) => void) {
  useEffect(() => {
    const handleVisibilityChange = () => {
      onVisibilityChange(document.hidden);
    };
    if (typeof document.hidden !== 'undefined') {
      document.addEventListener('visibilitychange', handleVisibilityChange, false);
      return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
    }
  }, [onVisibilityChange]);
}
